//@flow
import * as React from 'react'
import { Field } from 'redux-form'
import RFCheckboxField from '../../../components/ReduxFormComps/RFCheckboxField';
import SelectOrTextField from './SelectOrTextField'
import { checkboxCustomStyle,checkboxCustomLabelStyle } from '../../ProjectApollo/CheckboxUtil';
import type { ContainerRowReduxSelectAndOverrideField$Props } from '../flowTypes'

const checkboxOnChange=(e:any,props:ContainerRowReduxSelectAndOverrideField$Props)=>{
    const changeFieldValue = (props.changeFieldValue:any)
    if (e.target.checked){
       const selectFieldValue = props.parentProps[props.selectField] 
       const foundObject = props.datas.find((v)=>v[props.selectDataElement.code]==selectFieldValue)
       if (foundObject){
           changeFieldValue(props.textField,foundObject[props.selectDataElement.desc])
       }
    }else {
        changeFieldValue(props.textField,'')
    }
}

const ContainerRowReduxSelectAndOverrideField=(props:ContainerRowReduxSelectAndOverrideField$Props)=>{
    return (
        <div className='row'>
            <div className='col-sm'>
                <SelectOrTextField 
                    isOverride={props.isOverride} textField={props.textField} 
                    selectField={props.selectField}
                    label={props.label} datas={props.datas} 
                    selectDataElement={props.selectDataElement}
                />
                
                <Field name={props.checkboxField} 
                    component={RFCheckboxField} 
                    label={props.checkboxLabel}
                    customStyle={checkboxCustomStyle}
                    customLabelStyle={checkboxCustomLabelStyle(props.isOverride)}
                    onChange={(e)=>checkboxOnChange(e,props)}
                />
            </div>        
        </div>
    )
}

export default ContainerRowReduxSelectAndOverrideField


// WEBPACK FOOTER //
// ./src/views/ProjectDemeter/common/ContainerRowReduxSelectAndOverrideField.js